import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { ReportIncomeService } from './../report-income.service';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { ReportIncomeEventType } from './../report-income.event.type';
import { EventTypes } from '../../../shared/EventTypes';
import { TweenMax, Quint } from 'gsap';
import { ReportIncomeModel } from './../models/report-income'

@Component({
  selector: 'app-report-income-list',
  templateUrl: './report-income-list.component.html',
  styleUrls: ['./report-income-list.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class ReportIncomeListComponent implements OnInit {

  @Input() reportIncomeData: ReportIncomeModel;

  private view = '[data-component="report-income-list"]';
  active: boolean = false;
  yearsList: any = [];

  constructor(private reportIncomeService: ReportIncomeService) {}

  ngOnInit() {
    AppEventDispatcher.listen(ReportIncomeEventType.STEPS.REPORT_INCOME_LIST, data => {
          this.active = true;
          this.show();
    });
  }

  show() {
    this.preload(true);
    AppEventDispatcher.dispatch(ReportIncomeEventType.BUTTONS, { show: false });
    this.reportIncomeService.getYearsReport().subscribe(data => {
      this.yearsList = data;
      this.preload(false);
    });
  }

  hide() {
    TweenMax.to(this.view, 0.8, {
      delay: 0.4,
      left: '-120%',
      ease: Quint.easeOut,
      onComplete: () => {
        this.active = false;
      }
    });
  }

  getReportIncome(year) {
    this.preload(true);
    this.hide();
    TweenMax.delayedCall(1, () => {
      this.reportIncomeData.year = year;
      AppEventDispatcher.dispatch(ReportIncomeEventType.STEPS.REPORT_INCOME_CONFIRMATION, { show: true });
      this.preload(false);
    });
  }

  preload(active, delay = 0) {
    AppEventDispatcher.dispatch(EventTypes.PRELOAD,
      { element: '[data-component="report-income"] .content', show: active, delay: delay });
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/report-income/report-income-list/report-income-list.component.ts